//导入我们封装好的axios 
import service from './index'

//用户登录接
export const login = userInfo => service.post('service-user/user/login', userInfo);


//用户登录接
export const loginAli = userInfo => service.post('service-user/user/loginAli', userInfo); 

//用户ID获取电站列表
export const getPsInfoByUserId = userId => service.get('service-psinfo/psinfo/getPsInfoByUserId?userId='+userId);

//电站首页运行图
export const getPsSoipDatas = psId => service.get('service-psinfo/psdata/getPsSoipDatas?psId='+psId);


//获取验证码
export const userCodeOrEmail = (userCodeOrEmail,languageId) => service.post('service-user/user/forgetPassword?userCodeOrEmail='+userCodeOrEmail+"&languageId="+languageId);

//验证码修改用户密码
export const updatePassword = info => service.post('service-user/user/updatePassword',info);

//验证码修改用户密码（带用户ID验证）
export const updatePasswordByUser = info => service.post('service-user/user/updatePassword',info);

//验证用户密码
export const verifyUserPassword = (userId, password) => service.post('service-user/user/verifyUserPassword?userId='+userId+'&password='+encodeURIComponent(password));


//获取电站下所有设备
export const getDevicesByPsIdTypeId = psId => service.get('service-psinfo/psinfo/getDevicesByPsIdTypeId?deviceTypeId=&psId='+psId);

//获取采集器版本号信息
export const getPmuSn = (sn) => service.get('service-psinfo/pmusn/getPmuSn?sn='+sn);

//获取采集器状态
export const getPmuStatus = (pmuSn) => service.get('service-psinfo/pmusn/getPmuStatus?pmuSn='+pmuSn);

//发送采集器升级指令
export const sendPmuSnUpgrade = (pmuSn) => service.get('service-psinfo/pmusn/sendPmuSnUdp?pmuSn='+pmuSn);

//获取待初始化采集器列表
export const getPmuInitRecords = (psId) => service.get('service-psinfo/pmu/getPmuInitRecords?ps_id='+psId);

//初始化采集器指令
export const initPmuCommand = (pmuSn) => service.post('service-device/command/pmuInit', { pmuSn: pmuSn });

//检查采集器是否正在初始化
export const checkPmuInitializing = (pmuSn) => service.get('service-psinfo/checkPmuInitializing/checkPmuInitializing?pmuSn='+pmuSn);

export const getDevicesByPsIdTypeId2 = (psId,deviceTypeId) => service.get('service-psinfo/psinfo/getDevicesByPsIdTypeId?deviceTypeId='+deviceTypeId+'&psId='+psId);

//获取电站下所有设备分组
export const getDeviceTypeByPsId = psId => service.get('service-psinfo/psinfo/getDeviceTypeByPsId?psId='+psId);

//获取电站下所有设备分组
export const getDeviceGroupById = psId => service.get('service-psinfo/psinfo/getDeviceGroupById?psId='+psId);


//获取电站下DCDC明细数据
export const getDcdcDetailsByPsid = psId => service.get('service-device/dcdc/getDcdcDetailsByPsid?psId='+psId);

//获取电站下蓄电池明细数据
export const getRackDetailsByPsid = psId => service.get('service-device/rack/getRackDetailsByPsid?psId='+psId);

//获取电站下PCS明细数据
export const getPcsDetailsByPsid = psId => service.get('service-device/pcs/getPcsDetailsByPsid?psId='+psId);

//获取电站下PMS明细数据
export const getPmsDetailsByPsid = psId => service.get('service-device/Pms/getPmsDetailsByPsid?psId='+psId);

//获取电站下空调明细数据
export const getAirDetailsByPsid = psId => service.get('service-device/air/getAirDetailsByPsid?psId='+psId);

//获取电站下电表明细数据
export const getAmmeterDetailsByPsid = psId => service.get('service-device/ammeter/getAmmeterDetailsByPsid?psId='+psId);

//获取数据源提示信息
export const getDataSourceTipsBySourceNo = (id, sourceNo) => service.get(`service-psinfo/dataSourceTips/getByIdOrSourceNo?id=${id}&sourceNo=${encodeURIComponent(sourceNo)}`);

//获取电站统计数据
export const getPsTotalData = psId => service.get('service-psinfo/psdata/getPsTotalData?psId='+psId);

//获取电站天气信息
export const getWeatherByPsId = psId => service.get('service-psinfo/psdata/getBetweenWeatherByPsId?psId='+psId);

//获取电站统计数据显示设置
export const getPsDataSettings = psId => service.get('service-psinfo/psdata/getPsDataSettings?psId='+psId);

//获取电站下某设备类型的月统计数据
export const getDeviceDaysByPsidTypeid = (psId,deviceTypeId,searchDate) => service.get('service-device/pssys/getDeviceDaysByPsidTypeid?psId='+psId+'&deviceTypeId='+deviceTypeId+'&searchDate='+searchDate);

//获取电站下某设备类型的日统计数据
export const getDeviceDetailsByPsidTypeid = (psId,deviceTypeId,searchDate) => service.get('service-device/pssys/getDeviceDetailsByPsidTypeid?psId='+psId+'&deviceTypeId='+deviceTypeId+'&searchDate='+searchDate);

//获取电站下月统计数据
export const getDeviceMonthAmountByPsid = (psId,psTypeId,searchDate) => service.get('service-device/pssys/getDeviceMonthAmountByPsid?psId='+psId+'&psTypeId='+psTypeId+'&searchDate='+searchDate);

//获取电站下日统计数据
export const getDeviceDayPacsByPsid = (psId,psTypeId,searchDate) => service.get('service-device/pssys/getDeviceDayPacsByPsid?psId='+psId+'&psTypeId='+psTypeId+'&searchDate='+searchDate);


//保存电站统计数据显示设置
export const savePsDataSettings = (psId,psDataVisibleBoList) => service.post('service-psinfo/psdata/savePsDataSettings?psId='+psId,psDataVisibleBoList);

//注册用户接口
export const registerUser = (languageId,regData) => service.post('service-user/user/register?languageId='+languageId,regData);

//发送邮件
export const sendUserEmail = (userCode,languageId) => service.get('service-user/user/sendActiveMail?userCode='+userCode
+'&languageId='+languageId);


//用户数据更新
export const updateUserInfo = data => service.post('service-user/user/updateUserInfo',data);

//用户修改密码
export const updatePwd = data => service.post('/service-user/user/updatePwd',data);

//退出
export const logout = userId => service.get('service-user/user/logout?userId='+userId);

//获取国家
export const getCountrys = () => service.get('service-base/country/getCountrys');

//获取省份
export const getProvinces = countryId => service.get('service-base/province/getProvinces?countryId='+countryId);

//获取城市
export const getCitys = provinceId => service.get('service-base/base/getCitys?provinceId='+provinceId);

//获取电站信息
export const getPsInfoSmartomById = psId=> service.get('service-psinfo/psinfo/getPsInfoSmartomById?psId='+ psId)

//获取电站别称
export const getRidesPsInfoAliasName  = userId=> service.get('service-psinfo/psinfo/getRidesPsInfoAliasName?userId='+ userId)

//修改电站别称
export const addUpdateRidesPsAliasName = data => service.post('service-psinfo/psinfo/addUpdateRidesPsAliasName',data)

//修改电站信息
export const updatePsInfo = data => service.post('service-psinfo/psinfo/update',data)  

//获取电站类型
export const getPsTypes  = ()=> service.get('service-base/psType/getPsTypes')

//获取电站时区
export const getTimezones  = ()=> service.get('service-base/timezone/getTimezones')

//获取电站显示配置
export const getPsVisible  = (psId,psTypeId)=> service.get('service-base/psType/getPsVisible?psId='+psId+'&psTypeId='+psTypeId)

//保存电站显示配置
export const savePsVisible = (psId,data) => service.post('service-base/psType/savePsVisible?ps_id='+ psId,data)  

//获取某一日的故障数量
export const getPsAlarmCurrentBypsId = (psId,searchDate) =>service.get('service-device/api/error/getPsAlarmCurrentBypsId?psId='+psId+'&searchDate='+searchDate)

//告警月统计
export const getPsAlarmMonthDaysBypsId = (psId,searchDate) =>service.get('service-device/api/error/getPsAlarmMonthDaysBypsId?psId='+psId+'&searchDate='+searchDate)

//告警年统计
export const getPsAlarmYearMonthsBypsId = (psId,searchDate) =>service.get('service-device/api/error/getPsAlarmYearMonthsBypsId?psId='+psId+'&searchDate='+searchDate)

//告警故障列表
export const getCustomErrorDetail = (psId,searchDate,currentPage,pageCount,userId,deviceTypeId,languageId) =>service.get('service-warning/warning/getCustomErrorDetail?currentPage='+currentPage+'&pageCount='+pageCount+'&userId='+userId+'&psId='+psId+'&searchDate='+searchDate+'&deviceTypeId='+deviceTypeId+'&languageId='+languageId)

//告警通讯异常列表
export const getAbnormalCommunicationDetail = (psId,searchDate,currentPage,pageCount,userId) =>service.get('service-warning/warning/getAbnormalCommunicationDetail?currentPage='+currentPage+'&pageCount='+pageCount+'&userId='+userId+'&psId='+psId+'&searchDate='+searchDate)

//告警设备离线列表
export const getEquipmentOfflineDetail = (psId,searchDate,currentPage,pageCount,userId,deviceTypeId) =>service.get('service-warning/warning/getEquipmentOfflineDetail?currentPage='+currentPage+'&pageCount='+pageCount+'&userId='+userId+'&psId='+psId+'&searchDate='+searchDate+'&deviceTypeId='+deviceTypeId)


//获取邮件设置
export const getUserAlertEmailSendList = (userId) =>service.get('service-user/UserAlterEmailSend/getUserAlertEmailSendList?userId='+userId)


//获取邮件报警类型
export const getFailureTypes = () =>service.get('service-base/failureType/getFailureTypes')

//修改报警邮箱设置
export const updateUserAlertEmailSend = data =>service.post('service-user/UserAlterEmailSend/updateUserAlertEmailSend',data)


//删除报警邮箱设置
export const deleteUserAlertEmail = (userId,userAlertId) =>service.get('service-user/UserAlterEmailSend/deleteUserAlertEmail?userId='+userId+"&userAlertId="+userAlertId)


//添加报警邮件设置
export const addUserAlertEmailSend = data =>service.post('service-user/UserAlterEmailSend/addUserAlertEmailSend',data)


//发送报警警邮件设置
export const sendTestMail = (email,languageId) =>service.get('service-user/user/sendTestMail?email='+email+"&languageId="+languageId)

//根据用户ID获取用户信息
export const getUserInfo = (userId) =>service.get('service-user/user/getAccountInfo?userId='+userId)

//根据用户ID获取菜单 
export const getMenus = (userId) =>service.get('service-user/menu/getMenusByRoleId?userId='+userId)

//用户注册电站
export const addUserPsRole = data =>service.post('service-psinfo/psinfo/addUserPsRole',data)

//验证用户邮箱是否存在
export const userEmailIsExist = (userEmail) => service.get('service-user/user/userEmailIsExist?userEmail='+userEmail)

//验证电站ID或采集器序列号是否存在是否被使用
export const isExistPmuOrPs = (psIdSn) => service.get('service-psinfo/pmu/isExistPmuOrPs?ps_id_sn='+psIdSn)

//验证采集器SN是否存在、是否被使用、是否为解绑设备
export const isExistBindPmu = (sn) => service.get('service-psinfo/pmu/isExistBindPmu?sn='+sn)

//注册电站信息
export const registerByPmu = (userId,data) =>service.post('service-psinfo/psinfo/registerByPmu?userId='+userId,data)

//电站ID查询采集器列表
export const getPmuByPsId = (psId) => service.get('service-psinfo/pmu/getPmuByPsId?ps_id='+psId)

//根据用户ID、电站ID、采集器ID查询设备列表(分页)
export const getDevicePageListSmartOM = (userId,psId,pmuId,languageId,page,pageSize) => service.get('service-psinfo/psinfo/getDevicePageListSmartOM?userId='+userId+'&psId='+psId+'&pmuId='+pmuId+'&languageId='+languageId+'&page='+page+'&pageSize='+pageSize)

//修改采集器自定义名称
export const updatePmuName = (data) =>service.post('service-psinfo/pmu/updatePmuName',data)

//新添加采集器
export const addPmu = (data) =>service.post('service-psinfo/pmu/save',data)

//变更采集器
export const updatePmu = (pmu_id,pmu_sn,ps_id,user_id) =>service.get('service-psinfo/pmu/updatePmu?pmu_id='+pmu_id+'&pmu_sn='+pmu_sn+'&ps_id='+ps_id+'&user_id='+user_id)


//查询品牌信息
export const getBrandsByDevTypeId = (deviceTypeId) =>service.get('service-base/brand/getBrandsByDevTypeId?deviceTypeId='+deviceTypeId)

//查询型号信息
export const getModelsByBrandId = (brandId) =>service.get('service-base/model/getModelsByBrandId?brandId='+brandId)

//查询型号信息
export const getProtocolPlcDeviceTypeList = (protocolId) =>service.get('service-base/protocolPlcDevice/getProtocolPlcDeviceTypeList?protocolId='+protocolId)

//获取当前PLC设备的最大地址码
export const getMaxDeviceAddressPlc = (psId,pmuId) =>service.get('service-psinfo/psinfo/getMaxDeviceAddressPlc?psId='+psId+'&pmuId='+pmuId)

//同步设备
export const batchSaveDevice = (data) =>service.post('service-psinfo/psinfo/batchSaveDevice',data)

//检查设备地址码是否重复（REQ-003）
export const checkDeviceAddress = (boxId, deviceAddress) => service.get('service-psinfo/psinfo/checkDeviceAddress?boxId='+boxId+'&deviceAddress='+deviceAddress)

//获取设备列表（按电站+设备类型，REQ-001）
export const getDeviceListByPsId = (psId, deviceTypeId) => service.get('service-psinfo/psinfo/deviceList?psId='+psId+(deviceTypeId != null ? '&deviceTypeId='+deviceTypeId : ''))

//获取设备模板列表（REQ-002）
export const getDeviceTemplateList = (params) => {
  const query = Object.keys(params || {}).filter(k => params[k] != null).map(k => k+'='+params[k]).join('&')
  return service.get('service-psinfo/deviceTemplate/list'+(query ? '?'+query : ''))
}

//根据电站ID、采集器ID查询PLC设备列表
export const getDevicePlcListById = (psId,pmuId) =>service.get('service-psinfo/psinfo/getDevicePlcListById?psId='+psId+'&pmuId='+pmuId)

//根据用户ID、电站ID、采集器ID查询设备列表
export const getDeviceListSmartOMByPlcId = (psId,pmuId,languageId) => service.get('service-psinfo/psinfo/getDeviceListSmartOMByPlcId?psId='+psId+'&pmuId='+pmuId+'&languageId='+languageId)

//根据型号ID查询型号信息
export const getModelById = (modelId) =>service.get('service-base/model/getModelById?modelId='+modelId)

//设备类型信息
export const getDeviceTypes = () =>service.get('service-base/deviceType/getDeviceTypes')

//根据设备ID修改PLC设备列表
export const updateDevName = (deviceId,deviceName) =>service.get('service-psinfo/psinfo/updateDevName?deviceId='+deviceId+'&deviceName='+deviceName)


//判断采集器序列号是否存在（含解绑验证）
export const isExistPmuSn = (sn) => service.get('service-psinfo/pmusn/isExistPmuSn?sn='+sn)



//添加采集器(含解绑设备)
export const savePmu = (data) =>service.post('service-psinfo/pmu/savePmu',data)

//添加采集器(含解绑设备和备用采集器)
export const savePmus = (data) =>service.post('service-psinfo/pmu/savePmus',data)

//根据用户Id获取电站带角色
export const getPsUserRoleByUserId = (userId,psName,role,page,pageSize) => service.get('service-psinfo/psinfo/getPsUserRoleByUserId?userId='+userId+'&role='+role+'&psName='+psName+'&page='+page+'&pageSize='+pageSize)

//根据电站ID获取用户带角色
export const getUserRoleByPsId = (userId,psId) => service.get('service-psinfo/userPsRole/getUserRoleByPsId?userId='+userId+'&psId='+psId)

//修改用户的电站角色
export const updateUserRole = (data) => service.post('service-psinfo/userPsRole/update',data)

//删除用户的电站角色
export const deleteUserRole = (userRoleId,userId,psId,operator) => service.delete('service-psinfo/userPsRole/delete?userRoleId='+userRoleId+'&userId='+userId+'&psId='+psId+'&operator='+operator)

//userCode获取用户信息
export const getUserInfoByUserCode = userCode => service.get('service-user/user/getUserInfoByUserCode?userCode='+userCode)

//电站转让
export const psTrans = (data) => service.post('service-psinfo/userPsRole/psTrans',data)

//采集器下是否存在该设备名称
export const isDeviceNameByPmuId = (pmuId,deviceId,deviceName) => service.get('service-psinfo/psinfo/isDeviceNameByPmuId?pmuId='+pmuId+'&deviceId='+deviceId+'&deviceName='+deviceName)


//电站批量授权
export const insertUserPsRoleBatch = (data) => service.post('service-psinfo/userPsRole/insertUserPsRoleBatch',data)

//电站批量授权是否已存在
export const isUserRole = (data) => service.post('service-psinfo/userPsRole/isUserRole',data)

//获取电站授权转让日志
export const getPsRoleLogPage = (psName,logType,userId,createTime,page,pageSize) => service.get('service-user/syslog/getPsRoleLogPage?psName='+psName+'&logType='+logType+'&userId='+userId+'&createTime='+createTime+'&page='+page+'&pageSize='+pageSize)


//电站控制命令查询
export const getPlcDetailByPsid = (psId,searchDate,currentPage,pageSize) =>service.get('service-device/pssys/getPlcDetailByPsid?currentPage='+currentPage+'&pageSize='+pageSize+'&searchDate='+searchDate+'&psId='+psId)

//根据用户ID、电站ID、采集器ID查询设备列表
export const getDeviceListSmartOMByPsId = (psId,languageId) => service.get('service-psinfo/psinfo/getDeviceListSmartOMByPsId?psId='+psId+'&languageId='+languageId)



//故障报表下载
export const getErrorCsv = (psId,searchDate,userId,deviceTypeId,languageId,dateType) =>service.get('service-warning/warning/getErrorCsv?userId='+userId+'&psId='+psId+'&searchDate='+searchDate+'&deviceTypeId='+deviceTypeId+'&languageId='+languageId+'&dateType='+dateType)

//设备离线报表下载
export const getOfflineCsv = (psId,searchDate,userId,deviceTypeId,languageId,dateType) =>service.get('service-warning/warning/getOfflineCsv?userId='+userId+'&psId='+psId+'&searchDate='+searchDate+'&deviceTypeId='+deviceTypeId+'&languageId='+languageId+'&dateType='+dateType)

//电站通讯异常报表下载
export const getAbnormalCsv = (psId,searchDate,userId,deviceTypeId,languageId,dateType) =>service.get('service-warning/warning/getAbnormalCsv?userId='+userId+'&psId='+psId+'&searchDate='+searchDate+'&deviceTypeId='+deviceTypeId+'&languageId='+languageId+'&dateType='+dateType)

//电站阈值报警报表下载
export const getThresholdCsv = (psId,searchDate,userId,deviceTypeId,languageId,dateType) =>service.get('service-warning/warning/getThresholdCsv?userId='+userId+'&psId='+psId+'&searchDate='+searchDate+'&deviceTypeId='+deviceTypeId+'&languageId='+languageId+'&dateType='+dateType)


//故障屏蔽列表
export const queryFailureMaskDetailsPage = (userId,psId,maskType,failureName,searchDate,currentPage,pageCount,languageId) =>service.get('service-warning/failureMask/queryFailureMaskDetailsPage?currentPage='+currentPage+'&pageCount='+pageCount+'&userId='+userId+'&failureName='+failureName+'&psId='+psId+'&searchDate='+searchDate+'&maskType='+maskType+'&languageId='+languageId)

//取消故障屏蔽列表
export const cancelMask = id =>service.post('service-warning/failureMask/cancelMask?id='+id)


//获取故障屏蔽列表
export const getMaskErrorCsv = (currentPage,pageCount,deviceId,protocol,emsg,beginDate,endDate) =>service.get('service-warning/warning/getMaskErrorCsv?currentPage='+currentPage+'&pageCount='+pageCount+'&deviceId='+deviceId+'&protocol='+protocol+'&emsg='+emsg+'&beginDate='+beginDate+'&endDate='+endDate)


//屏蔽故障
export const maskFailure = (maskInfo) =>service.post('service-warning/failureMask/maskFailure',maskInfo)


//获取阈值报警设置的设备类型列表
export const queryDeviceType = () => service.get('service-warning/thresholdType/queryDeviceType')


//获取阈值报警设置的设备类型的参数列表
export const queryThresholdType = (deviceTypeId) => service.get('service-warning/thresholdType/queryThresholdType?deviceTypeId='+deviceTypeId)

//获取阈值报警设置的设备类型的参数列表
export const queryThresholdMath = () => service.get('service-warning/thresholdMath/queryThresholdMath?thresholdTypeId=')

//保存阈值报警设置
export const saveThreshold = (data) => service.post('service-warning/threshold/saveThreshold',data)

//获取阈值报警列表
export const queryThresholdList = (userId,psId,status,page,pageSize) => service.get('service-warning/threshold/queryThresholdList?userId='+userId+'&psId='+psId+'&status='+status+'&page='+page+'&pageSize='+pageSize)

//删除阈值报警设置
export const deleteThreshold = (userId,psId,thresholdId) => service.get('service-warning/threshold/deleteThreshold?thresholdId='+thresholdId+'&userId='+userId+'&psId='+psId)

//阈值报警列表
export const getEquipmentThresholdDetailsByPsIds = (psId,searchDate,currentPage,pageCount,userId,deviceTypeId) =>service.get('service-warning/warning/getThresholdDetail?currentPage='+currentPage+'&pageCount='+pageCount+'&userId='+userId+'&psId='+psId+'&searchDate='+searchDate+'&deviceTypeId='+deviceTypeId)

//获取阈值报警日志列表
export const queryThresholdListPage = (userId,psId,status,createTime,page,pageSize) => service.get('service-warning/threshold/queryThresholdListPage?userId='+userId+'&psId='+psId+'&status='+status+'&createTime='+createTime+'&page='+page+'&pageSize='+pageSize)

//获取阈值报警日志
export const getThresholdLogPage = (psName,logType,userId,createTime,page,pageSize) => service.get('service-user/syslog/getThresholdLogPage?psName='+psName+'&logType='+logType+'&userId='+userId+'&createTime='+createTime+'&page='+page+'&pageSize='+pageSize)

//获取电站下年统计数据 searchDate格式 YYYY
export const getAllDeviceYearDataByPsId = (psId,psTypeId,searchDate) => service.get('service-device/pssys/getAllDeviceYearDataByPsId?psId='+psId+'&psTypeId='+psTypeId+'&searchDate='+searchDate);

//获取电站下月统计数据 searchDate格式 YYYY-MM~YYYY-MM
export const getAllDeviceMonthDataByPsId = (psId,psTypeId,searchDate) => service.get('service-device/pssys/getAllDeviceMonthDataByPsId?psId='+psId+'&psTypeId='+psTypeId+'&searchDate='+searchDate);

//获取电站下日统计数据 searchDate格式 YYYY-MM-DD~YYYY-MM-DD
export const getAllDeviceDayDataPacsByPsId = (psId,psTypeId,searchDate) => service.get('service-device/pssys/getAllDeviceDayDataPacsByPsId?psId='+psId+'&psTypeId='+psTypeId+'&searchDate='+searchDate);

//获取电站下某设备类型的年统计数据 searchDate格式 YYYY
export const getAllDeviceYearDataByPsIdTypeId = (psId,deviceTypeId,searchDate) => service.get('service-device/pssys/getAllDeviceYearDataByPsIdTypeId?psId='+psId+'&deviceTypeId='+deviceTypeId+'&searchDate='+searchDate);

//获取电站下某设备类型的月统计数据 searchDate格式 YYYY-MM~YYYY-MM
export const getAllDeviceMonthDataByPsIdTypeId = (psId,deviceTypeId,searchDate) => service.get('service-device/pssys/getAllDeviceMonthDataByPsIdTypeId?psId='+psId+'&deviceTypeId='+deviceTypeId+'&searchDate='+searchDate);

//获取电站下某设备类型的日统计数据 searchDate格式 YYYY-MM-DD~YYYY-MM-DD
export const getAllDeviceDayDataByPsIdTypeId = (psId,deviceTypeId,searchDate) => service.get('service-device/pssys/getAllDeviceDayDataByPsIdTypeId?psId='+psId+'&deviceTypeId='+deviceTypeId+'&searchDate='+searchDate);

//根据电站ID，设备类型ID，日期范围 获取指定类型的所有设备的日报表 上传到OSS searchDate格式 YYYY-MM-DD~YYYY-MM-DD
export const getAllDeviceDayDataByPsIdTypeIdFromOSS = (language, psId, psTypeId, deviceTypeId, searchDate, fileName, userId) => service.get('service-device/pssys/getAllDeviceDayDataByPsIdTypeIdFromOSS?language='+language+'&psTypeId='+psTypeId+'&psId='+psId+'&deviceTypeId='+deviceTypeId+'&searchDate='+searchDate+'&fileName='+fileName+'&userId='+userId);

//根据电站ID，日期范围 获取日报表 上传到OSS searchDate格式 YYYY-MM~YYYY-MM
export const getAllDeviceDayDataPacsByPsIdFromOSS = (language, psId, psTypeId, searchDate, fileName, userId) => service.get('service-device/pssys/getAllDeviceDayDataPacsByPsIdFromOSS?language='+language+'&psId='+psId+'&psTypeId='+psTypeId+'&searchDate='+searchDate+'&fileName='+fileName+'&userId='+userId);

//根据taskId获取报表URL
export const getReportURLByTaskId = (taskId) => service.get('service-device/pssys/getReportURLByTaskId/' + taskId);

//根据taskId删除报表URL
export const removeReportURLByTaskId = (taskId) => service.get('service-device/pssys/removeReportURLByTaskId/' + taskId);


//判断当前电站设备的状态是否异常
export const getWarningStatus = (psId) => service.get('service-warning/warning/getWarningStatus?psId='+psId)

export const getCurrentWarning = (userId, psIds) => service.get('service-warning/warning/getCurrentWarning?userId='+userId + '&psIds='+psIds)

//获取JEPX日统计数据
export const getJepxDayByPsId = (psId,searchDate) => service.get('service-psinfo/jpex/getJepxDayByPsId/?psId='+psId+'&searchDate='+searchDate);

//获取JEPX月统计数据
export const getJepxMonthByPsId = (psId,searchDate) => service.get('service-psinfo/jpex/getJepxMonthByPsId/?psId='+psId+'&searchDate='+searchDate);

//获取JEPX年统计数据
export const getJepxYearByPsId = (psId,searchDate) => service.get('service-psinfo/jpex/getJepxYearByPsId/?psId='+psId+'&searchDate='+searchDate);

//获取JEPX总统计数据
export const getJepxTotalByPsId = (psId) => service.get('service-psinfo/jpex/getJepxTotalByPsId/?psId='+psId);

//获取JEPX收益来源配置
export const queryJepxIncomeSourceByPsId = (psId) =>
	service.get('service-psinfo/jepxIncomeSource/queryByPsId?psId=' + psId);

//获取月电费财务日期统计数据
export const queryMonthlyElectricityFinance = (psId, date) =>
	service.get('service-psinfo/monthlyElectricityFinance/queryDateStatistics?psId=' + psId + (date ? '&date=' + date : ''));

//查询月电费收支汇总
export const queryMonthlySummary = (psId, reportMonth) =>
	service.get('service-psinfo/monthlyElectricityFinance/queryMonthStatistics?psId=' + psId + '&date=' + reportMonth);

//查询年电费收支汇总
export const queryYearStatistics = (psId, reportYear) =>
	service.get('service-psinfo/monthlyElectricityFinance/queryYearStatistics?psId=' + psId + '&date=' + reportYear);

//查询总电费收支统计
export const queryTotalStatistics = (psId) =>
	service.get('service-psinfo/monthlyElectricityFinance/queryTotalStatistics?psId=' + psId);


//获取JEPX日明细数据
export const getJepxDetailByPsId = (psId, beginDate, endDate) => service.get('service-psinfo/jpex/getJepxDetailByPsId/?psId='+psId+'&beginDate='+beginDate+'&endDate='+endDate);

//获取JEPX月每日的统计数据
export const getJepxDaysByPsId = (psId, beginDate, endDate) => service.get('service-psinfo/jpex/getJepxDaysByPsId/?psId='+psId+'&beginDate='+beginDate+'&endDate='+endDate);


//获取JEPX年每月的统计数据
export const getJepxMonthsByPsId = (psId, beginDate, endDate) => service.get('service-psinfo/jpex/getJepxMonthsByPsId/?psId='+psId+'&beginDate='+beginDate+'&endDate='+endDate);


//获取JEPX年的统计数据
export const getJepxYearsByPsId = (psId) => service.get('service-psinfo/jpex/getJepxYearsByPsId/?psId='+psId);

//获取日的一次调频完成的记录图数据
export const getFrequencyPicOss = (psId,searchDate) => service.get('service-device/frequency/getFrequencyPicOss/?psId='+psId+'&searchDate='+searchDate);

//获取调频参数P0-P7
export const getFrequencyParams = (psId,FmBeginTime) => service.get('service-device/frequency/getFrequencyChangeParam/?psId='+psId+'&FmBeginTime='+FmBeginTime);

//获取省份对应的区域
export const getPsAreaJp = (psId) => service.get('service-psinfo/psinfo/getPsAreaJp/?psId='+psId);

//查询指定日期的调频合格率数据半小时的记录

//获取一次调频质量图数据
export const getFrequencyModulation = (psId,beginTime,endTime) => service.get('service-device/frequency/getFrequencyModulation/?psId='+psId+'&beginTime='+beginTime+'&endTime='+endTime);

//获取30分钟的调频质量
export const queryFrequencyQuality30ByDate = (psId,searchDate) => service.get('service-device/frequency/queryFrequencyQuality30ByDate/?psId='+psId+'&searchDate='+searchDate);

//获取电站下的采集器的序列号及服务年限开始时间
export const getPmusnInfoByPsId = (psId) => service.get('service-psinfo/pmusn/getPmusnInfoByPsId?psId='+psId)

//获取最新3条公告
export const getLatestNotice = () => service.get('service-user/notice/getLatestNotice')

//根据类型获取公告信息
export const getNoticeByType = (type) => service.get('service-user/notice/getNoticeByType?type='+type)

//获取每周密码（仅超级管理员）
export const getWeeklyPassword = (userId) => service.get('service-user/user/getWeeklyPassword?userId='+userId)

//获取频率详情数据（按时间段）
export const getFrequencyInfoDetailByKoma = (psId, beginDate, endDate) => service.get('service-device/frequency/getFrequencyFrequencyInfoDetailByKoma?psId='+psId+'&beginDate='+encodeURIComponent(beginDate)+'&endDate='+encodeURIComponent(endDate))

//获取月的异常频率koma
export const getFrequencyAbnormalKoma = (psId, searchDate) => service.get('service-device/frequency/getFrequencyAbnormalKoma?psId='+psId+'&searchDate='+encodeURIComponent(searchDate))

//根据时间段获取异常状态
export const getAbnormalStatusByRegion = (psId, beginDate) => service.get('service-device/frequency/getAbnormalStatusByRegion?psId='+psId+'&beginDate='+encodeURIComponent(beginDate))

